<template>
    <transition name="fadeIn" appear>
        <div class="slider">
            <div class="images">
                <SensitiveOverlay
                    v-if="sensitiveOverlay"
                    @displayMedia="showSensitive=true"/>
                <VueCompareImage
                    :class="['compare', { sensitive: sensitiveOverlay }, { notSensitive: !sensitiveOverlay }]"
                    :leftImage="currentArtwork.media.slider.left.url"
                    :rightImage="currentArtwork.media.slider.right.url"
                    :sliderLineWidth="2"
                    :handleSize="40"/>
            </div>

            <BlurredBackground
                :image="currentArtwork.media.slider.right.url"/>
        </div>
    </transition>
</template>

<script>
    import VueCompareImage from 'vue-compare-image'
    import SensitiveOverlay from '@/components/entry/SensitiveOverlay'

    export default {
        name: 'Slider',
        components: {
            VueCompareImage,
            SensitiveOverlay
        },
        props: {
            currentArtwork: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                showSensitive: false
            }
        },
        computed: {
            sensitiveOverlay() {
                if(this.showSensitive) {
                    return false
                } else if(this.currentArtwork.flag.sensitive && !this.preferences.showSensitive) {
                    return true
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .slider {
        max-width: 100%;
        padding: 0 0.5rem;
        height: auto;
    }

    .images {
        position: relative;
        touch-action: none;
        margin-top: 1rem;
        border-radius: 1rem;
        overflow: hidden;
    }

    .compare {
        transition: $transition-eio-60;
    }

    .sensitive {
        filter: blur(4rem) brightness(0.8);
    }

    .notSensitive {
        filter: blur(0) brightness(1);
    }

    @media all and (max-width: 560px) {
        .images {
            margin-top: 0;
            border-radius: 0 0 1rem 1rem;
        }

        .slider {
            padding: 0;
        }
    }
</style>